import React from 'react'

class IssueNavigation extends React.Component {
  constructor(props) {
    super(props)
  }

  render () {
    const issue_navigation = [
      { name: 'moving_image',
        title: 'moving image' },
      { name: 'still_image',
        title: 'still image' },
      { name: 'textz',
        title: 'textz' },
      { name: 'soundz',
        title: 'soundz' }
      ].map((section_metadata, index) => {
        return this.props.issue_data[`${section_metadata.name}_count`] > 0 ?
          <li key={index}><a href={`/issue/${this.props.issue_data.issue_date}/${section_metadata.name}/1`}>{section_metadata.title}</a></li> : null;
      })

    return (
      <ul>
          {issue_navigation.map(item => item)}
      </ul>
    );
  }
}

export default IssueNavigation


// WEBPACK FOOTER //
// ./src/components/issue_navigation.js